import React from "react";
import { useState, useEffect, useRef } from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
type Props = {
  ScreenID: number;
  ScorecardFiltersCallBack: any;
};
function ScorecardFilters(props: Props) {
  const [scorecardFiltersData, setScorecardFiltersData] = useState({
    StatusData: [],
    Dealers: [],
    Facilities: [],
    Years: [],
    Months: [],
    Brand: [],
  });

  if (props.ScreenID !== 7) {
    // remmember
    AppContext.ScoreCardFiltersIDs = {
      Dealers: 0,
      Facilities: 0,
      Years: 0,
      Months: 0,
      Brand: 0,
    };
  } else {
    if (
      AppContext.ScoreCardFiltersIDs.Dealers == 0 ||
      AppContext.ScoreCardFiltersIDs.Facilities == 0
    ) {
      AppContext.ScoreCardFiltersIDs = {
        ScreenID: 0,
        Dealers: 15,
        Facilities: 9,
        Years: 0,
        Months: 0,
        Brand: 0,
      };
    }
  }

  const [selectedId, setSelectedId] = useState({
    ...AppContext.ScoreCardFiltersIDs,
  });

  useEffect(() => {
    getLoadFilters();
  }, [selectedId.Dealers, selectedId.Years, selectedId.ScreenID]);

  useEffect(() => {
    sendResponseToParent();
  }, [selectedId.Facilities, selectedId.Months, selectedId.Brand]);

  function habdleFilterChange() {
    // first update dealerid and year id in centerler variable
    //now call load the filters
  }

  function getLoadFilters() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.dealerid = selectedId.Dealers;
    object.year = selectedId.Years;
    object.sc = selectedId.ScreenID;
    object.sdid = selectedId.Dealers;
    object.sfid = selectedId.Facilities;
    object.sbid = selectedId.Brand;
    object.syid = selectedId.Years;
    object.smid = selectedId.Months;
    axiosAuth
      .post(AppContext.AppBaseURL + "api/PFIRSFactorKey/GetLoadFilters", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setScorecardFiltersData((prevState: any) => ({
            ...prevState,
            StatusData: l_response[0],
            Dealers: l_response[1],
            Facilities: l_response[2],
            Years: l_response[3],
            Months: l_response[4],
            Brand: l_response[5],
          }));

          if (l_response[0]) {
            // selectedId.Dealers = l_response[0][0].SelectedDealerID;
            // if (props.ScreenID === 7) {
            //   selectedId.Facilities = l_response[2][0].PID;
            // } else {
            //   selectedId.Facilities = l_response[0][0].SelectedFacilityID;
            // }
            selectedId.Brand = l_response[0][0].SelectedBrandID;
            selectedId.Years = l_response[0][0].SelectedYear;
            selectedId.Months = l_response[0][0].SelectedMonth;

            AppContext.NetworkTotalScore = l_response[0][0].NetworkTotalScore;
            AppContext.SalesTotalScore = l_response[0][0].SalesTotalScore;
            AppContext.AftersalesTotalScore =
              l_response[0][0].AftersalesTotalScore;
          }

          sendResponseToParent();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function sendResponseToParent() {
    AppContext.ScoreCardFiltersIDs = selectedId;
    props.ScorecardFiltersCallBack(selectedId);
  }

  return (
    <>
      <div>
        <select
          className="input-field select-field"
          value={selectedId.Dealers}
          onChange={(e) =>
            setSelectedId((prevState: any) => ({
              ...prevState,
              Dealers: e.target.value,
            }))
          }
        >
          {props.ScreenID !== 7 && <option value={0}>All Retailers</option>}
          {scorecardFiltersData.Dealers &&
            scorecardFiltersData.Dealers.map((Item: any, index) => (
              <option value={Item.PID} key={"Dealers" + Item.PID}>
                {Item.Name}
              </option>
            ))}
        </select>
      </div>

      {parseInt(selectedId.Dealers) !== 0 && (
        <div>
          <select
            className="input-field select-field"
            value={selectedId.Facilities}
            onChange={(e) =>
              setSelectedId((prevState: any) => ({
                ...prevState,
                Facilities: e.target.value,
              }))
            }
          >
            {props.ScreenID !== 7 && <option value={0}>All Facilities</option>}
            {scorecardFiltersData.Facilities &&
              scorecardFiltersData.Facilities.map((Item: any, index) => (
                <option value={Item.PID} key={"Facilities" + Item.PID}>
                  {Item.Name}
                </option>
              ))}
          </select>
        </div>
      )}

      <div>
        <select
          className="input-field select-field"
          value={selectedId.Brand}
          onChange={(e) =>
            setSelectedId((prevState: any) => ({
              ...prevState,
              Brand: e.target.value,
            }))
          }
        >
          {scorecardFiltersData.Brand &&
            scorecardFiltersData.Brand.map((Item: any, index) => (
              <option value={Item.PID} key={"Brand" + Item.PID}>
                {Item.Name}
              </option>
            ))}
        </select>
      </div>

      <div>
        <select
          className="input-field select-field"
          value={selectedId.Years}
          onChange={(e) =>
            setSelectedId((prevState: any) => ({
              ...prevState,
              Years: e.target.value,
            }))
          }
        >
          {scorecardFiltersData.Years &&
            scorecardFiltersData.Years.map((Item: any, index) => (
              <option value={Item.PID} key={"Years" + Item.PID}>
                {Item.Name}
              </option>
            ))}
        </select>
      </div>

      {props.ScreenID !== 10 && props.ScreenID !== 8 && (
        <div>
          <select
            className="input-field select-field"
            value={selectedId.Months}
            onChange={(e) =>
              setSelectedId((prevState: any) => ({
                ...prevState,
                Months: e.target.value,
              }))
            }
          >
            {scorecardFiltersData.Months &&
              scorecardFiltersData.Months.map((Item: any, index) => (
                <option value={Item.PID} key={"Months" + Item.PID}>
                  {Item.Name}
                </option>
              ))}
          </select>
        </div>
      )}
    </>
  );
}

export default React.memo(ScorecardFilters);
